import { badgeRecipe } from './badge.recipe';
import { textRecipe } from './text.recipe';

export const recipes = {
	badge: badgeRecipe,
	text:  textRecipe,
};
